import script from "./NetSalaryInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./NetSalaryInfo.vue?vue&type=script&setup=true&lang=ts"

import "./NetSalaryInfo.vue?vue&type=style&index=0&id=77d3578f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d3578f"]])

export default __exports__